// extracted by mini-css-extract-plugin
export default {"controls":"Controls_controls__ehb05","plusIcon":"Controls_plusIcon__5Y2t2"};